import { render, staticRenderFns } from "./EditDnsBatch.vue?vue&type=template&id=16b84d96"
import script from "./EditDnsBatch.vue?vue&type=script&lang=js"
export * from "./EditDnsBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports